import { Alert, Box, Button, Container, FormField, KeyValuePairs, RadioGroup, Select, TimeInput } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { mdiRefresh, mdiTrophyOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useEffect, useRef, useState } from 'react';
import Copy from '../../../../../components/Copy';
import DPModal from '../../../../../components/DPModal';
import DRPicker from '../../../../../components/DRPicker';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Confirm from '../../../../../components/extras/Confirm';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelMovementPax from '../../../../../components/extras/SidePanelMovement';
import TableMovementsPax from '../../../../../components/tables/tableMovementsPAX';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnDanger, btnIconForm, btnWarn, ItemsMovement } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, formatDate, formatPhone, formatTime, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;

export const OPSMercenariesPAXPage = () => {
  //const storeAdmin = useStoreAdmin();

  const { menu, data, parameters } = useGlobalState();
  const [detailPanel, setDetailPanel] = useState(false);
  const [movements, setMovements] = useState<ItemsMovement[]>([]);
  const [movement, setMovement] = useState<Partial<ItemsMovement>>();
  const [movementSold, setMovementSold] = useState<Partial<ItemsMovement>>();
  const [idMovement, setIdMovement] = useState<number>(0);
  const [dateProgram, setDateProgram] = useState<string>("");
  const [timeProgram, setTimeProgram] = useState<string>("");
  const [programId, setProgramId] = useState("");
  const [renderTrigger, setRenderTrigger] = useState(0);

  const voucherStage = useRef(-2);
  const voucherStages = [
    { label: 'Todos', value: "-2" },
    { label: 'No programado', value: "0" },
    { label: 'En venta', value: "1" },
    { label: 'Adjudicado', value: "2" },
    { label: 'Realizado', value: "3" },
    { label: 'Anulado', value: "-1" },
  ]
  useEffect(() => {
    handleRefreshMovements();
  }, [parameters]); //parameters.startDate, parameters.endDate, 

  useEffect(() => {

  }, [parameters]);

  useEffect(() => {
    if (idMovement === 0) {
      //setTitle("Estado de aeronaves");
    } else {
      //setTitle("Estado " + (equipment ? equipment.registration : ""));
    }
  }, [idMovement]);

  const cancelReasons = [
    { label: "Cambio de fecha", value: "PAX.CHANGE" },
    { label: "Cancelación de vuelo por pasajero", value: "PAX.CANCEL" },
    { label: "Pasajero no se presenta", value: "PAX.NOSHOW" },
    { label: "Mercenario no se presenta", value: "MERCENARY.NOSHOW" },
    { label: "Condiciones meterológicas", value: "METEO" },
  ]
  const mountedRef = useRef(false);


  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");
      if (id) {
        if (!mountedRef.current) {
          mountedRef.current = true;
          handleRefreshMovements()

        }
        handleGethMovement(id ? parseInt(id) : 0);
      } else {
        handleRefreshMovements();
      }
    }

    window.addEventListener("hashchange", handleHashChange);
    // also trigger once on mount
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);


  const handleGethMovement = async (idMovement: number) => {
    //if (parameters.startDate && parameters.endDate) {
    if (idMovement > 0) {

      try {
        setLoading(true)
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/movements/movement',
            'JWT': getCookie("JWT"),
            //  
          },
          body: JSON.stringify({
            idMovement: idMovement
          }),
          //mode: 'no-cors'  // Bypasses CORS but limits the response
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const data = await response.json();
        addNotificationStatus(data, setData);
        if (data.code == 0) {

          const mv = data.movement;
          setDateProgram(formatDate(mv?.jsonMovement?.dateProgram ?? ""));
          setTimeProgram(formatTime(mv?.jsonMovement?.dateProgram ?? ""));

          setMovement(mv);

          setIdMovement(data.movement.idMovement);
        }
      } catch (error: any) {
        //console.log(error)
        addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
      } finally { setLoading(false) }

    };
  }

  const handleRefreshMovements = async () => {
    if (parameters.startDate && parameters.endDate) {
      try {
        setMovement(undefined)
        setLoading(true)
        console.log("voucherStage:", voucherStage)

        const body: any = {
          ...(voucherStage.current !== -2 && { voucherStage: voucherStage.current }),

          dateStart: parameters.startDate,
          dateEnd: parameters.endDate,
          idAccountPlan: 83024,
          isPax: true,
          orderBy: "dateTransaction",
          order: "desc",
          orderBy2: "idMovement",
          order2: "desc",
          columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName,idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK, voucherStage, idFlight, hashMovement, obs",
          limit: 2000
          // other properties here...
        };

        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/movements/list',
            'JWT': getCookie("JWT"),
            //  
          },
          body: JSON.stringify(body),
          //mode: 'no-cors'  // Bypasses CORS but limits the response
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const data = await response.json();
        addNotificationStatus(data, setData);
        if (data.code == 0) {
          setMovements(data.movements);
        }
      } catch (error: any) {
        addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
      } finally { setLoading(false) }

    };
  }

  const handleMovementSold = async () => {
    //if (parameters.startDate && parameters.endDate) {
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/movements/update',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({ idMovement: movementSold.idMovement, voucherStage: 2, idUser: movementSold.idUser }),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0) {
        window.location.hash = "ops/mercenaries/pax"
        setMovementSold(undefined)
        setProgramId("")
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }

  };


  const handleCancelProgram = async () => {
    //if (parameters.startDate && parameters.endDate) {
    if (movement.jsonMovement.voidReason !== "") {
      //
      try {
        setLoading(true)
        let mv = {
          idMovement: movement.idMovement,
          cancelReason: movement.jsonMovement.voidReason
        }
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/movements/pax/cancel',
            'JWT': getCookie("JWT"),
            //  
          },
          body: JSON.stringify(mv),
          //mode: 'no-cors'  // Bypasses CORS but limits the response
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const data = await response.json();
        addNotificationStatus(data, setData);
        if (data.code == 0) {
          window.location.hash = "ops/mercenaries/pax"
          setProgramId("")
          setMovement(undefined)
        }
      } catch (error: any) {
        addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
      } finally { setLoading(false) }

    };
  }

  const handleProgramDate = async () => {
    //if (parameters.startDate && parameters.endDate) {
    if (dateProgram !== "" && timeProgram !== "") {
      //
      try {
        setLoading(true)
        let mv = {
          idMovement: movement.idMovement,
          voucherStage: 1,
          dateProgram: dateProgram + " " + timeProgram,
        }
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/movements/pax/program',
            'JWT': getCookie("JWT"),
            //  
          },
          body: JSON.stringify(mv),
          //mode: 'no-cors'  // Bypasses CORS but limits the response
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const data = await response.json();
        addNotificationStatus(data, setData);
        if (data.code == 0) {
          window.location.hash = "ops/mercenaries/pax"
          setProgramId("")
        }
      } catch (error: any) {
        addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
      } finally { setLoading(false) }

    };
  }


  const handleGetVoucher = async (id: number) => {
    //if (parameters.startDate && parameters.endDate) {
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/movements/pax/voucher',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({ idMovement: id }),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0) {
        handleSavePdf(data.pdf, `voucher_${id}.pdf`);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }

  const handleSavePdf = (base64Data: any, fileName = "voucher.pdf") => {
    // 1. Convert Base64 to binary
    // Note: Handle potential "data:application/pdf;base64," prefix if your backend adds it
    const base64Content = base64Data.includes(",") ? base64Data.split(",")[1] : base64Data;

    const byteCharacters = atob(base64Content);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    // 2. Trigger the download in the browser
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    // 3. Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  };

  const btnActionDisabled = () => {
    console.log(movement.jsonMovement.voidReason)
    if (programId === "") return true;
    if (programId === "void")
      if (!movement.jsonMovement.voidReason || movement.jsonMovement.voidReason === "") return true;
    if (programId === "program")
      if (dateProgram === "" || timeProgram?.length !== 5) return true;
    if (programId === "sold") return false;

    return false;
  }
  return (
    <CustomAppLayout
      toolsHide
      splitPanelOpen={detailPanel}
      onSplitPanelToggle={({ detail }) => setDetailPanel(detail.open)}
      splitPanel={
        <SidePanelMovementPax movement={movement ?? {}} />
      }

      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>
          <SpaceBetween direction="vertical" size="xs">

            <Header
              actions={
                <>{idMovement !== 0 ? <Button variant='link' onClick={() => {
                  window.location.hash = '#ops/mercenaries/pax';
                  //setMovement(undefined);
                }}>Volver</Button> : ""}<Favorites /></>
              }
            >
              Ventas de turnos PAX
            </Header>


            {!!movement && (
              <SpaceBetween direction="vertical" size="xs">
                <Copy value={movement?.idMovement?.toString() ?? ""} />
                <SpaceBetween direction="vertical" size="xs">
                  <Container header={<Header variant='h3'
                    actions={<Button variant="normal" onClick={() => {
                      handleGetVoucher(movement.idMovement);
                    }}>Voucher</Button>
                    }
                  >PAX {
                      <BadgeCustom color={movement.voucherStage === 0 ? "light" : movement.voucherStage === 1 ? "blue" : movement.voucherStage === 2 ? "green" : movement.voucherStage === 3 ? "violet" : "dark"}>
                        {movement.voucherStage === 0 ? "No iniciado" : movement.voucherStage === 1 ? "En venta" : movement.voucherStage === 2 ? "Vendido" : movement.voucherStage === 3 ? "Realizado" : "Desconocido"}</BadgeCustom>}</Header>}
                  >
                    <SpaceBetween direction="vertical" size="xs">
                      <KeyValuePairs
                        columns={1}
                        items={[
                          { label: "Pasajero", value: movement.jsonMovement.nombre },
                        ]}
                      />
                      <KeyValuePairs
                        columns={2}
                        items={[
                          { label: "Móvil", value: formatPhone(movement.jsonMovement.movil) },
                          { label: "Email", value: movement.jsonMovement.email },
                        ]}
                      />

                      <KeyValuePairs
                        columns={1}
                        items={[
                          { label: "Observaciones", value: movement.jsonMovement.obs },
                        ]}
                      />
                      {movement?.jsonMovement?.dateEndSell !== "" && movement?.voucherStage === 1 && (
                        <Alert type="info" header="Información">
                          Venta finaliza el: <b>{movement?.jsonMovement?.dateEndSell}</b>
                        </Alert>
                      )}
                    </SpaceBetween>
                  </Container>

                  <Container header={<Header variant='h3'
                  >Acciones</Header>}
                    footer={
                      programId !== "" && (
                        <Box float="right">

                          <Button disabled={btnActionDisabled()}
                            variant='primary'
                            style={{ root: programId == "program" ? null : programId == "void" ? btnDanger : programId == "sold" ? btnWarn : null }} onClick={() => {
                              console.log(programId)

                              if (programId == "program") {
                                if (dateProgram !== "" && timeProgram?.length === 5) {
                                  handleProgramDate();
                                }
                              }
                              else if (programId == "void") {
                                handleCancelProgram()
                              }
                              else if (programId == "sold") {
                                setMovementSold(movement)
                              }

                            }}>{programId == "" ? "Acción" : programId == "program" ? "Programar" : programId == "void" ? "Cancelar" : programId == "sold" ? "Vender" : ""}</Button>
                        </Box>
                      )}
                  >
                    <RadioGroup value={programId}
                      onChange={(e) => {
                        setProgramId(e.detail.value)
                      }}
                      items={[
                        {
                          value: "program",
                          label: "Programar",
                          description:
                            programId == "program" && (
                              <SpaceBetween direction="horizontal" size="xs">
                                <FormField label="Fecha de vuelo">
                                  <DPModal date={dateProgram}
                                    readonly={movement["voucherStage"] === 3}
                                    start={new Date()}
                                    onConfirm={(date: string) => {
                                      setDateProgram(date);
                                    }} />
                                </FormField>

                                <div style={{ width: 110 }}>
                                  <FormField label="Hora de vuelo">
                                    <div onMouseDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
                                      <TimeInput
                                        autoComplete={false}

                                        readOnly={movement["voucherStage"] === 3}
                                        format="hh:mm" value={timeProgram} onChange={(event) => {
                                          setTimeProgram(event.detail.value);
                                        }} />
                                    </div>
                                  </FormField>
                                </div>
                              </SpaceBetween>
                            ),
                          disabled: movement.voucherStage !== 0
                        },

                        {
                          value: "void",
                          label: "Cancelar",
                          description:
                            programId == "void" && (
                              <SpaceBetween direction="vertical" size="xs">
                                <FormField label="Motivo de anulación">
                                  <div onMouseDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()} style={{ width: 200 }} >
                                    <Select options={cancelReasons}
                                      expandToViewport
                                      selectedOption={cancelReasons.find((r: any) => r.value === movement.jsonMovement.voidReason)}
                                      onChange={(e) => {
                                        setMovement({ ...movement, jsonMovement: { ...movement.jsonMovement, voidReason: e.detail.selectedOption.value } });
                                      }}

                                    />
                                  </div>
                                </FormField>
                                Eliminar la venta mercenario de un turno. En el caso de haber sido adjudicado, ganador volverá a su posición inicial en la lista de prioridades
                              </SpaceBetween>
                            ),
                          disabled: (movement["voucherStage"] === 3 || movement["voucherStage"] === 0)
                        },

                        {
                          value: "sold",
                          label: "Vendido",
                          description: "Pasa al estado vendido un voucher, para poder facturarlo a un vuelo sin necesariamente haber pasado por la venta de mercenarios",
                          disabled: !(movement["voucherStage"] === 0)

                        }
                      ]}
                    />
                  </Container>

                  <SpaceBetween direction="vertical" size="xs">
                    {movement?.idUser === 6559 && movement.voucherStage !== 0 ? (
                      movement?.jsonMovement?.mercenaries?.length > 0 ? (
                        <Container header={<Header variant='h3'>Mercenarios asociados</Header>}>
                          <SpaceBetween direction="vertical" size="xs">
                            {movement.jsonMovement.mercenaries
                              .sort((a: any, b: any) =>
                                b.won !== a.won
                                  ? b.won - a.won
                                  : a.displayName.localeCompare(b.displayName)
                              )
                              .map((mercenary: any, index: number) => (
                                <FormField
                                  key={mercenary.idUser ?? index}
                                  label={
                                    <>
                                      {mercenary.won == 1 && (
                                        <Icon path={mdiTrophyOutline} size={1} />
                                      )}{" "}
                                      {mercenary.displayName}
                                    </>
                                  }
                                />
                              ))}
                          </SpaceBetween>
                        </Container>
                      ) : (
                        <Alert type="warning" header="Postulantes">
                          Sin postulantes inscritos</Alert>
                      )
                    ) : null}
                  </SpaceBetween>
                </SpaceBetween>
              </SpaceBetween>
            )}
            {!movement && (
              <>
                <SpaceBetween direction="horizontal" size="xs">
                  <DRPicker start={parameters.startDate} end={parameters.endDate}
                    onConfirm={(startDate: string, endDate: string) => {

                      if (startDate && endDate) {
                        const updatedParameters = { ...parameters, startDate: startDate, endDate: endDate, };
                        setParameters(updatedParameters);
                      }
                    }}
                  />

                  <Select
                    key={`voucherStageSelect${voucherStage.current}`}
                    selectedOption={voucherStages.find(option => Number(option.value) === voucherStage.current) || null}
                    onChange={({ detail }) => {
                      voucherStage.current = (Number(detail.selectedOption.value))
                      console.log("voucherStageChanged")
                      setRenderTrigger(prev => prev + 1);
                      handleRefreshMovements();
                    }}
                    options={voucherStages}
                  />
                  {parameters.idUser > 0 && (<Button style={{ root: btnIconForm }} onClick={() => handleRefreshMovements()} ><Icon path={mdiRefresh} size={1} /></Button>)}

                </SpaceBetween>
                {parameters.startDate !== '' && parameters.endDate !== '' && (
                  <TableMovementsPax onSelect={(movement) => {
                    location.hash = '#ops/mercenaries/pax?id=' + movement.idMovement.toString()

                  }} movements={movements} visible={true}
                    onRangeChange={(startDate, endDate) => {
                      const updatedParameters = { ...parameters, startDate: startDate, endDate: endDate, };
                      setParameters(updatedParameters);

                    }}
                  />
                )}
              </>
            )}
            {!!movementSold && (
              <Confirm type='warning' show={!!movementSold} action={'Decretar'} warning={`Decretar el movimiento PAX #${movementSold.idMovement} como vendido`} onDismiss={() => setMovementSold(undefined)} onConfirm={() => {
                handleMovementSold()
              }} />
            )}
          </SpaceBetween>



        </>
      }
    />
  );
};
